import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import ModuleForm from './ModuleForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog, Typography } from '@material-ui/core';
import ModelAssetList from '../asset/ModelAssetList';
import ModuleSchedule from './ModuleSchedule';
import * as validatorActions from '../../components/validator/store/actions';
import TabPanelButtons from '../../components/TabPanelButtons';
import PageHeader from 'main/components/PageHeader';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import StaticRelationList from '../../components/StaticRelationList';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '128px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Module extends Component {
    state = {
        current_tab: 0,
        company_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false,
        lockDialogActive: false,
        unlockDialogActive: false,
        activateDialogActive: false
    }

    constructor(props) {
        super(props);

        const module_id = this.props.match.params.module_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            module_id: module_id,
            view_type: view_type,
        }

        this.props.updateModuleLoaded(false);
        if (view_type !== 'create') {
            this.props.getModuleData(module_id);
        } else {
            this.props.updateModuleLoaded(true);
            this.props.getAllLessons();
            this.props.getCompanyList();
        }
        const validationList = [
            {
                field_name: 'ModuleName', functionName: ['checkRequiredFilled']
            }
        ]

        this.props.startValidator(validationList)
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.updateModuleListLoaded(false);
                    this.props.saveModule(this.props.currentModule, this.props.currentModuleLessonList, auth_id, this.props.companies);
                    this.props.history.push('/module/list');
                    break;
                }

            case ("edit"):
                {
                    this.props.updateModuleListLoaded(false);
                    this.props.saveModule(this.props.currentModule, this.props.currentModuleLessonList, auth_id, this.props.companies)
                    this.props.history.push('/module/list');
                    break;
                }

            default:
                { }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleLockDialogOpen = () => {
        this.setState({ lockDialogActive: true });
    }

    handleActivateDialogOpen = () => {
        this.setState({ activateDialogActive: true });
    }

    handleUnlockDialogOpen = () => {
        this.setState({ unlockDialogActive: true });
    }

    handleLock = () => {
        this.props.lockModule(this.props.currentModule.module_id, this.props.auth.user.data.auth_id);
        this.setState({ lockDialogActive: false });
        return true
    }

    handleUnlock = () => {
        this.props.unlockModule(this.props.currentModule.module_id);
        this.setState({ unlockDialogActive: false });
        return true
    }

    handleActivate = () => {
        console.log('handle activate')
        this.props.activateModule(this.props.currentModule.module_id, this.props.auth.user.data.auth_id);
        this.setState({ activateDialogActive: false });
        return true
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteModule(this.props.currentModule.module_id);
                    this.props.history.push('/module/list');
                    break;
                }

            default:
                {

                }

        }
    }

    getPageContent = (current_tab, view_type) => {
        const { classes,
            currentModule,
            allLessons,
            currentModuleLessonList,
            theme
        } = this.props;

        switch (current_tab) {
            case (0):
                {
                    return (
                        <ModuleForm
                            view_type={view_type}
                        />
                    )
                }
            case (1):
                {
                    return (
                        <ModelAssetList
                            view_type={view_type}
                            model_type='module'
                            model_id={this.props.currentModule.module_id}
                            file_type="Module File"
                            assetList={this.props.currentModule.assetList}
                            getAssetList={this.props.getModuleAssetList}
                            updateAssetNameFunc={this.props.updateAssetName}
                        />
                    )
                }
            case (2):
                {
                    return (
                        <ModuleSchedule
                            view_type={view_type}
                            scheduleWeeksNeeded={this.props.scheduleWeeksNeeded}
                            alreadySelectedLessons={currentModuleLessonList}
                            allLessons={allLessons}
                            module_id={currentModule.module_id}
                        />
                    )
                }
            case (3): // Company
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={this.props.companies}
                                        header='Companies'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <RelationUpdateTabs
                                currentRelationsTabData={this.props.companies}
                                handleDelete={this.props.toggleCompany}
                                availableObjectList={this.props.allCompanies}
                                handleAdd={this.props.toggleCompany}
                                handleSearchChange={this.handleCompanySearchChange}
                                search={this.props.companySearch}
                                leftHeader="Current Companies"
                                rightHeader="All Companies"
                                view_type={view_type}
                                rootClass={classes.root}
                                dir={theme.direction}
                            />
                    );
                }
        }
    }

    getActivateDialog = (active, module) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ activateDialogActive: false })}
            >
                <DialogTitle>Confirm Activate {module.ModuleName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleActivate()} color="primary">
                        Activate
                        </Button>
                    <Button onClick={() => this.setState({ activateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getDeleteDialog = (active, module) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Deactivate {module.ModuleName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">The following relationships will be deactivated:</Typography>
                            {this.props.currentModuleCourseList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Courses</Typography>
                                    {this.props.currentModuleCourseList.map(c => {
                                        return (
                                            <Typography variant="body1" key={c.course_id}>{c.CourseName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.currentModuleLessonList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Lessons</Typography>
                                    {this.props.currentModuleLessonList.map(l => {
                                        return (
                                            <Typography variant="body1" key={l.lesson_id}>{l.LessonName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.module_on_calendar.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.module_on_calendar.map(c => {
                                        return (
                                            <Typography variant="body1" key={c.company_calendar_day_id}>{c.CompanyName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                        </React.Fragment>

                    }


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Deactivate
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getLockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ lockDialogActive: false })}
            >
                <DialogTitle>Lock Module?</DialogTitle>
                <DialogContent>
                    Only you and Company Admin level users will be able to edit the module.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleLock()} color="primary">
                        Lock
                        </Button>
                    <Button onClick={() => this.setState({ lockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getUnlockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ unlockDialogActive: false })}
            >
                <DialogTitle>Unlock Module?</DialogTitle>
                <DialogContent>
                    All company instructors will be able to edit this module.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleUnlock()} color="primary">
                        Unlock
                        </Button>
                    <Button onClick={() => this.setState({ unlockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    getLockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its already locked
        if (this.props.currentModule.IsLocked === 1) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentModule.CreateAuthID) {
            return true;
        }
        return false;
    }

    getUnlockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its not locked
        if (this.props.currentModule.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentModule.CreateAuthID) {
            return true;
        }
        return false;
    }

    hideLockedModuleActions = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;

        if (this.props.currentModule.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return false;
        }
        else if (role === 'instructor' && auth_id === this.props.currentModule.LockedByAuthID) {
            return false;
        }
        return true;
    }

    handleCompanySearchChange = (e) => {
        this.props.companyUpdateSearch(e.target.value)
    }

    render() {
        const { classes, currentModule, isModuleLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentModule);
        const lock_dialog = this.getLockDialog(this.state.lockDialogActive);
        const unlock_dialog = this.getUnlockDialog(this.state.unlockDialogActive);
        const activate_dialog = this.getActivateDialog(this.state.activateDialogActive, this.props.currentModule)
        const authRole = this.props.auth.user.data.role_info.role_id;

        const deleteTooltipContent =
            <React.Fragment>
                {this.props.currentModuleCourseList.length > 0 ? <h5>Courses depending on this module:</h5> : null}
                {this.props.currentModuleCourseList.map(c => {
                    return (
                        <div key={c.course_id}>{c.CourseName}</div>
                    )
                })}
                {this.props.module_on_calendar.length > 0 ? <h5>Module on following calendars:</h5> : null}
                {this.props.module_on_calendar.map(m => {
                    return (
                        <div key={m.company_calendar_module_id}>{m.CompanyName}: {m.StartDate} - {m.EndDate}</div>
                    )
                })}
            </React.Fragment>

        if (!isModuleLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isModuleLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name={currentModule.ModuleName}
                        component_type={"module"}
                        view_type={view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Assets"
                                // disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Schedule"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Company"
                                    // disabled={view_type === 'create'}
                                    hidden={authRole > 2}
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"module"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "unlock",
                                        type: "lock",
                                        onClick: this.handleUnlockDialogOpen,
                                        hidden: !this.getUnlockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "lock",
                                        type: "lock",
                                        onClick: this.handleLockDialogOpen,
                                        hidden: !this.getLockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "Save",
                                        type: view_type === 'create' ? 'create' : 'update',
                                        onClick: this.handleSubmit,
                                        disabled: this.disableSave(),
                                        hidden: this.hideLockedModuleActions()
                                    },
                                    {   
                                        display: 'deactivate',
                                        largeLabel: true,
                                        type: "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteTooltipContent },
                                        hidden: this.hideLockedModuleActions() || this.props.currentModule.Active === 0
                                    },
                                    {
                                        type: "activate",
                                        largeLabel: true,
                                        onClick: this.handleActivateDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteTooltipContent },
                                        hidden: this.hideLockedModuleActions() || this.props.currentModule.Active === 1

                                    },
                                    {
                                        type: "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {unlock_dialog}
                            {lock_dialog}
                            {delete_dialog}
                            {page_content}
                            {activate_dialog}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getModule: Actions.getModule,
        updateModuleLoaded: Actions.updateModuleLoaded,
        getModuleData: Actions.getModuleData,
        deleteModule: Actions.deleteModule,
        saveModule: Actions.saveModule,
        updateModuleForm: Actions.updateModuleForm,
        toggleLesson: Actions.toggleLesson,
        toggleCourse: Actions.toggleCourse,
        getModuleAssetList: Actions.getModuleAssetList,
        getAllLessons: Actions.getAllLessons,
        startValidator: validatorActions.startValidator,
        lockModule: Actions.lockModule,
        unlockModule: Actions.unlockModule,
        companyUpdateSearch: Actions.companyUpdateSearch,
        toggleCompany: Actions.toggleCompany,
        updateModuleListLoaded: Actions.updateModuleListLoaded,
        getCompanyList: Actions.getCompanyList,
        activateModule: Actions.activateModule,
        updateAssetName: Actions.updateAssetName
    }, dispatch);
}

function mapStateToProps({ moduleApp, auth, validator }) {
    return {
        currentModule: moduleApp.modules.currentModule,
        allCourses: moduleApp.modules.allCourses,
        allLessons: moduleApp.modules.allLessons,
        currentModuleLessonList: moduleApp.modules.currentModuleLessonList,
        currentModuleCourseList: moduleApp.modules.currentModuleCourseList,
        isModuleLoaded: moduleApp.modules.isModuleLoaded,
        scheduleWeeksNeeded: moduleApp.modules.scheduleWeeksNeeded,
        deleteAllowed: moduleApp.modules.deleteAllowed,
        module_on_calendar: moduleApp.modules.module_on_calendar,
        validator: validator.list,
        companies: moduleApp.modules.companies,
        allCompanies: moduleApp.modules.allCompanies,
        companySearch: moduleApp.modules.companySearch,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Module)));



// WEBPACK FOOTER //
// src/main/content/module/Module.js